module.exports = __webpack_public_path__ + "img/cmm.3da63282.svg";